import $ from 'jquery'
import Splide from '@splidejs/splide'
import { Fancybox } from '@fancyapps/ui'

Fancybox.bind(`[data-gallery="gallery-boat"]`, {
    groupAll: true,
    Toolbar: {
        display: {
            left: [],
            middle: [],
            right: ['close'],
        },
    },
    Thumbs: {
        type: 'classic',
    },
})